<mat-sidenav-container autosize>
  <mat-sidenav #sidenav mode="side" opened class="ds-lib-main-menu" [disableClose]="true">
    <ds-lib-main-menu
      [tabs]="tabs"
      [rights]="rightsManagerService.rights"
      [user]="currentUser"
      [productLogos]="productLogos"
      [(selectedTabId)]="selectedTabId"
      (linkClicked)="menuLinkClicked($event)"
      (tabClicked)="menuTabClicked($event)"
      (homeClicked)="menuHomeClicked($event)"
      (selectItemClicked)="onSelectItemClicked($event)"
      class="ds-lib-main-menu"
    >
    </ds-lib-main-menu>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-progress-bar
      color="accent"
      mode="indeterminate"
      class="ds-loader-bar"
      *ngIf="dsLoaderService.loaderState | async"
    ></mat-progress-bar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
